import { AutosaveManager } from "@coze-studio/autosave";

import { type ParameterStoreProps, useParameterStore } from "@rokid/store";
import { type ItemType } from "./type.ts";
import { globalImagesizeConfig } from "./config.ts";

export const createGlobalImagesizeSaveManager = (saveRequest:any) => {
  return new AutosaveManager<ParameterStoreProps, ItemType, any>({
    store: useParameterStore,
    registers: [globalImagesizeConfig],
    saveRequest,
  });
};
